import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// ==================== COMPANIES API ====================

export const getCompanies = async () => {
  try {
    const response = await axios.get(`${API}/companies`);
    return response.data;
  } catch (error) {
    console.error('Error fetching companies:', error);
    throw error;
  }
};

export const getCompanyById = async (companyId) => {
  try {
    const response = await axios.get(`${API}/companies/${companyId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching company:', error);
    throw error;
  }
};

export const getCompanyByDomain = async (domain) => {
  try {
    const response = await axios.get(`${API}/companies/domain/${domain}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching company by domain:', error);
    throw error;
  }
};

export const createCompany = async (companyData) => {
  try {
    const response = await axios.post(`${API}/companies`, companyData);
    return response.data;
  } catch (error) {
    console.error('Error creating company:', error);
    throw error;
  }
};

export const updateCompany = async (companyId, updateData) => {
  try {
    const response = await axios.put(`${API}/companies/${companyId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating company:', error);
    throw error;
  }
};

export const deleteCompany = async (companyId) => {
  try {
    const response = await axios.delete(`${API}/companies/${companyId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting company:', error);
    throw error;
  }
};

// ==================== REVIEWS API ====================

export const getReviews = async (companyId = null, skip = 0, limit = 100) => {
  try {
    let url = `${API}/reviews?skip=${skip}&limit=${limit}`;
    if (companyId) {
      url += `&company_id=${companyId}`;
    }
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching reviews:', error);
    throw error;
  }
};

export const getReviewById = async (reviewId) => {
  try {
    const response = await axios.get(`${API}/reviews/${reviewId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching review:', error);
    throw error;
  }
};

export const createReview = async (reviewData) => {
  try {
    const response = await axios.post(`${API}/reviews`, reviewData);
    return response.data;
  } catch (error) {
    console.error('Error creating review:', error);
    throw error;
  }
};

export const updateReview = async (reviewId, updateData) => {
  try {
    const response = await axios.put(`${API}/reviews/${reviewId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating review:', error);
    throw error;
  }
};

export const deleteReview = async (reviewId) => {
  try {
    const response = await axios.delete(`${API}/reviews/${reviewId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting review:', error);
    throw error;
  }
};

export const addCompanyResponse = async (reviewId, responseData) => {
  try {
    const response = await axios.post(`${API}/reviews/${reviewId}/response`, responseData);
    return response.data;
  } catch (error) {
    console.error('Error adding company response:', error);
    throw error;
  }
};
